export async function addToClipBoard(message: string) {
    navigator.clipboard.writeText(message)
}


export async function makeBytes(trans:any) {
    let transBytes = trans.toBytes();
    return transBytes;
}
